import { ChakraProvider, Spinner, useBoolean, useDisclosure } from "@chakra-ui/react";
import md5 from "blueimp-md5";
import { useEffect, useMemo, useState } from "react";
import { BsStar, BsStarFill } from "react-icons/bs";
import { Button } from "../../components/button/Button";
import { useUrl } from "../../Utils";
import FavouriteModal from "./FavouriteModal";
import { checkFavourite, deleteFavourite, saveFavourite } from "./Services";

const FavButton = ({ size,  attributes }) => {
  let url = useUrl(attributes.url);
  const [check, setCheck] = useState();
  const [loader, setLoader] = useBoolean();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialize = () => {
    checkFavourite(md5(url))
        .then(data => {
          setCheck(data.check);
        })
        .finally(_ => setLoader.off());
  }

  useEffect(() => {
    if (!!(url)) {
      setLoader.on();
      initialize()
    }
  }, []);

  useEffect(() => {
    document.addEventListener('favourite-deleted', () => {
      initialize();
    });
    return () => {
      document.removeEventListener('favourite-deleted')
    }
  }, []);

  const onSave = (data) => {
    setLoader.on();
    saveFavourite(data)
      .then(data => setCheck(data.check))
      .finally(_ => setLoader.off());
  }

  const onDelete = (id) => {
    setLoader.on();
    deleteFavourite({ id: id })
      .then(data => setCheck(data.check))
      .finally(_ => setLoader.off());
  }

  const favouriteModal = useMemo(() => {
    if (isOpen) {
      return <FavouriteModal url={url} target={attributes.target} isOpen={isOpen} onClose={onClose} onSave={onSave} onDelete={onDelete} />
    } else {
      return null
    }
  }, [isOpen]);

  return (<ChakraProvider>
    <button className={`bf-favourite-button ${(!!size) ? 'bf-favourite-sm' : ''}`} type="button" onClick={onOpen}>
      {(!loader) ? ((check) ? <BsStarFill /> : <BsStar />) : <Spinner color="white" size="xs" />}
    </button>
    {favouriteModal}
  </ChakraProvider>)
}

export { FavButton };